import {
  CalligraphyLayoutSkeleton,
  SuspensePageBoundary,
} from "@-/dev.improve.haniverse.components.ui.suspense-page";
import { WordReferenceCaligraphyScreenSuspense } from "#word-reference-caligraphy-screen-suspense";

export function WordReferenceCaligraphyScreen({ word }: { word: string }) {
  return (
    <SuspensePageBoundary fallback={<CalligraphyLayoutSkeleton />} location={import.meta.location}>
      <WordReferenceCaligraphyScreenSuspense word={word} />
    </SuspensePageBoundary>
  );
}
